// Routes du budget et de la chaîne de la dépense (lot L4-B, M06), raccordées dans Application.tsx par
// une seule ligne.
import type { RouteObject } from 'react-router';
import { PageBudget } from './PageBudget';
import { PageDepense } from './PageDepense';
import { PageImport } from './PageImport';

export const routesBudget: RouteObject[] = [
  { path: '/budget', element: <PageBudget /> },
  { path: '/budget/depense', element: <PageDepense /> },
  { path: '/budget/import', element: <PageImport /> },
];
